import { observer } from 'mobx-react-lite'
import { FullPageWrapper } from 'shared/ui'
import { ReviewsList } from './ReviewsList'

export const AllReviews = observer(() => {
  return (
    <FullPageWrapper>
      <ReviewsList />
    </FullPageWrapper>
  )
})
